import { lazyLoad } from 'utils/loadable';

export const NewOrderLoadable = lazyLoad(
  () => import('./Container/NewOrder'),
  module => module.NewOrder,
);
